export default __webpack_public_path__ + "img/tracker.bd511c85.png";